import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody } from 'react-magma-dom';
import { InfoIcon } from 'react-magma-icons';
class ToolsetPlaceholderComponent extends React.PureComponent {
  static propTypes = {
    message: PropTypes.string.isRequired
  };

  render () {
    return (
      <Card style={{ height: '200px' }} testId="toolset-placeholder">
        <CardBody
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 'inherit'
          }}
        >
          <div className="mr-10 flex">
            <InfoIcon aria-hidden="true" size="28" />
          </div>
          {this.props.message}
        </CardBody>
      </Card>
    );
  }
}

export default ToolsetPlaceholderComponent;
